export const STEPPER_FORM_DATA_KEY = 'stepper-form-data';
